import { Companion_getInstance3d08n7snrwep7 as Companion_getInstance } from './ExecutionContext.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { HttpHeader1d7ldebjomr00 as HttpHeader } from './http/Http.mjs';
import { plus20p0vtfmu0596 as plus } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var BuilderClass;
function Builder() {
  if (BuilderClass === VOID) {
    class $ {
      constructor(operation) {
        this.t42_1 = operation;
        this.u42_1 = null;
        this.v42_1 = Companion_getInstance().g43_1;
        this.w42_1 = null;
        this.x42_1 = null;
        this.y42_1 = null;
        this.z42_1 = null;
        this.a43_1 = null;
        this.b43_1 = null;
        this.c43_1 = null;
        this.d43_1 = null;
        this.e43_1 = null;
        this.f43_1 = true;
      }
      h43(requestUuid) {
        // Inline function 'kotlin.apply' call
        this.u42_1 = requestUuid;
        return this;
      }
      i43(executionContext) {
        // Inline function 'kotlin.apply' call
        this.v42_1 = executionContext;
        return this;
      }
      j43(ignoreApolloClientHttpHeaders) {
        // Inline function 'kotlin.apply' call
        this.c43_1 = ignoreApolloClientHttpHeaders;
        return this;
      }
      k43(httpMethod) {
        // Inline function 'kotlin.apply' call
        this.w42_1 = httpMethod;
        return this;
      }
      l43(httpHeaders) {
        // Inline function 'kotlin.apply' call
        this.x42_1 = httpHeaders;
        return this;
      }
      m43(name, value) {
        // Inline function 'kotlin.apply' call
        var tmp = this;
        var tmp0_elvis_lhs = this.x42_1;
        tmp.x42_1 = plus(tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs, new (HttpHeader())(name, value));
        return this;
      }
      n43(sendApqExtensions) {
        // Inline function 'kotlin.apply' call
        this.z42_1 = sendApqExtensions;
        return this;
      }
      o43(sendDocument) {
        // Inline function 'kotlin.apply' call
        this.a43_1 = sendDocument;
        return this;
      }
      p43(enableAutoPersistedQueries) {
        // Inline function 'kotlin.apply' call
        this.y42_1 = enableAutoPersistedQueries;
        return this;
      }
      q43(canBeBatched) {
        // Inline function 'kotlin.apply' call
        this.b43_1 = canBeBatched;
        return this;
      }
      r43(retryOnError) {
        // Inline function 'kotlin.apply' call
        this.d43_1 = retryOnError;
        return this;
      }
      s43(failFastIfOffline) {
        // Inline function 'kotlin.apply' call
        this.e43_1 = failFastIfOffline;
        return this;
      }
      t43(sendEnhancedClientAwareness) {
        // Inline function 'kotlin.apply' call
        this.f43_1 = sendEnhancedClientAwareness;
        return this;
      }
      d38() {
        var tmp0_elvis_lhs = this.u42_1;
        return new (ApolloRequest())(this.t42_1, tmp0_elvis_lhs == null ? uuid4() : tmp0_elvis_lhs, this.v42_1, this.w42_1, this.x42_1, this.z42_1, this.a43_1, this.y42_1, this.b43_1, this.c43_1, this.d43_1, this.e43_1, this.f43_1);
      }
    }
    initMetadataForClass($, 'Builder');
    BuilderClass = $;
  }
  return BuilderClass;
}
var ApolloRequestClass;
function ApolloRequest() {
  if (ApolloRequestClass === VOID) {
    class $ {
      constructor(operation, requestUuid, executionContext, httpMethod, httpHeaders, sendApqExtensions, sendDocument, enableAutoPersistedQueries, canBeBatched, ignoreApolloClientHttpHeaders, retryOnError, failFastIfOffline, sendEnhancedClientAwareness) {
        this.u43_1 = operation;
        this.v43_1 = requestUuid;
        this.w43_1 = executionContext;
        this.x43_1 = httpMethod;
        this.y43_1 = httpHeaders;
        this.z43_1 = sendApqExtensions;
        this.a44_1 = sendDocument;
        this.b44_1 = enableAutoPersistedQueries;
        this.c44_1 = canBeBatched;
        this.d44_1 = ignoreApolloClientHttpHeaders;
        this.e44_1 = retryOnError;
        this.f44_1 = failFastIfOffline;
        this.g44_1 = sendEnhancedClientAwareness;
      }
      h44() {
        return this.i44(this.u43_1);
      }
      i44(operation) {
        return (new (Builder())(operation)).h43(this.v43_1).i43(this.w43_1).k43(this.x43_1).l43(this.y43_1).n43(this.z43_1).o43(this.a44_1).p43(this.b44_1).q43(this.c44_1).r43(this.e44_1).s43(this.f44_1).j43(this.d44_1).t43(this.g44_1);
      }
    }
    initMetadataForClass($, 'ApolloRequest');
    ApolloRequestClass = $;
  }
  return ApolloRequestClass;
}
//region block: exports
export {
  Builder as Builder32honxq3tatym,
};
//endregion

//# sourceMappingURL=ApolloRequest.mjs.map
